export const POS_APP_TYPES = {
  RETAIL: 1,
  REPORTING: 2,
  SCANNER: 3
}

export const GetAppTypes = {
  LOGIN: 'login',
  NETWORK: 'network',
  ROUTES: 'routes',
  // LOGOUT: 'logout' // // NOTE: logout jab b app se hoga to web per zrort nai logout karny ki --> reasn complicated find in notes
  REGISTER_POPUP: 'registerPopup',
  LANG_ID: 'langId',
  LANGUAGE: 'language',
  OUTLET_USERS: 'outletUsers'
}

export const PostAppTypes = {
  SETUP_DONE: 'setupDone',
  LOGIN_DONE: 'loginDone',
  LOGOUT: 'logout',
  LOGOUT_DONE: 'logoutDone',
  OUTLET: 'outlet',
  REGISTER: 'register',
  PAGE_HEADER: 'pageHeader',
  RECIEPT_PRINT: 'recieptPrint',
  DEBUG: 'debug',
  OPEN_DRAWER: 'openDrawer',
  EXCEL_B_64: 'exportBase64',
  APP_ROUTES: 'appRoutes',
  OUTLET_USERS: 'outletUsers'
}

export const NumPadTypes = {
  QUANTITY: 1,
  PRICE: 2,
  DISCOUNT: 3,
  CUSTOMER: 4,
  AMOUNT_TO_PAY: 5,
  WHOLE_DISCOUNT: 6
}

export const APP_PRINT_TYPES = {
  SALE: 1,
  XZREPORT: 2,
  OPENCLOSE: 3
}

export const ATTRIB_MODAL_TYPES = {
  PARK_SALE: 1,
  RETRIEVE_SALE: 2
}

export const APP_ROUTES_CONFIGS = {
  HardwareScreen: 'HardwareScreen'
}
